//西班牙语
export default{
  首页:"página delantera",
我的资产:"mis bienes",
重置登录密码:"Restablecer contraseña de inicio de sesión",
重置登录密码后:"Después de restablecer la contraseña de inicio de sesión, los retiros de moneda y las transferencias OTC están prohibidos dentro de las 24 horas.",
请选择:"por favor elige",
密码在:"La contraseña tiene entre 6 y 16 caracteres y consta de números y letras.",
请确认密码:"Por favor, confirme su contraseña",
产品列表:"Lista de productos",
币种:"Divisa",
期限:"el término",
订单列表:"Lista de orden",
交易用:"Para negociar",
立即入金开始您的第一笔交易:"Deposite dinero ahora para comenzar su primera operación",
立即入金:"Depositar ahora",
币种对:"par de divisas",
涨幅:"Aumentar",
交易量:"Volumen de comercio",
欢迎登录:"Ingresa, por favor",
登录:"Acceso",
新用户注册:"Registro de nuevo usuario",
总资产折合:"Activos totales convertidos",
冻结:"congelar",
折合:"convertido",
充值币种:"Recargar moneda",
充值数量:"Cantidad de recarga",
确认信息:"Confirmar información",
充币网络:"Red de deposito",
欢迎注册:"Bienvenido a registrarse",
点击打开:"Haga clic para abrir",
这是一段信息:"Este es un dato",
提币数量:"Cantidad de monedas retiradas",
提币:"retirar monedas",

百万用户首选:"La primera elección de millones de usuarios.",
小时成交量:"Volumen de operaciones las 24 horas",
优质数字资产:"Activos digitales de alta calidad",
我们的核心产品:"Nuestros productos principales",
你可以选择丰富的交易方式:"Puede elegir entre una variedad de métodos comerciales",
现货:"Productos al contado",
我们提供:"proporcionamos",
币种的交易服务:"Servicios de comercio de divisas",
合约:"contrato",
使用合约丰富你的交易体验:"Utilice contratos para enriquecer su experiencia comercial",
赚币:"Ganar monedas",
行业内领先收益:"Ingresos líderes en la industria",
多元化的产品服务:"Productos y servicios diversificados.",
选择更多:"Elige más servicios y explora infinitas posibilidades",
福利中心:"centro de bienestar",
完成新手任务:"Completa tareas de novato",
会员:"miembro",
享受全网最多权益:"Disfrute de los mayores beneficios en toda la red",
社区:"Comunidad",
在这里发现币圈财富机会:"Descubra aquí oportunidades de riqueza en el círculo monetario",
随时随地开启交易:"Comience a operar en cualquier momento y en cualquier lugar",
全面支持:"Apoyo total",
和:"y",

交割:"Entrega",
关于我们:"sobre nosotros",
账变记录:"Registros de cambios de cuenta",
股票:"existencias",
加密货币:"criptomoneda",
加载中:"cargando...",
已经全部加载完毕:"Todos han sido cargados",
暂无记录:"No hay registros",
高级认证:"Certificación avanzada",
姓名:"Nombre",
请输入姓名:"Por favor escribe tu nombre",
护照编号:"Número de pasaporte",
请输入护照编号:"Por favor ingrese el número de pasaporte",
护照照片:"Foto del pasaporte",
申请认证:"Solicitar la certificación",
提示:"pista",
确定:"Seguro",
提交失败:"Envío fallido",
上传失败:"subida fallida",
身份认证:"Autenticación",
身份证号:"número de identificación",
请输入身份证号:"Por favor ingrese el número de identificación",
身份证照片:"foto de identificación",
申请认证:"Solicitar la certificación",
修改资金密码:"Cambiar contraseña de fondo",
旧密码:"Contraseña anterior",
请输入旧密码:"Por favor ingrese la contraseña anterior",
新密码:"Nueva contraseña",
请输入6位数字:"Por favor ingrese 6 dígitos",
确认新密码:"Confirma la nueva contraseña",
请再次输入新密码:"Por favor ingrese nuevamente la nueva contraseña",
提交:"entregar",
请输入新密码:"Por favor ingrese una nueva contraseña",
请输入6位数新密码:"Por favor ingrese una nueva contraseña de 6 dígitos",
请确认两次密码输入一致:"Confirme que las dos contraseñas ingresadas sean consistentes",
修改登录密码:"Cambiar contraseña de inicio de sesión",
密码长度:"Contraseña (6-12 caracteres)",
密码长度提示:"Introduzca entre 6 y 12 caracteres, incluidos números o letras.",
客服:"Servicio al Cliente",
永续:"Sostenible",
交割:"Entrega",
永续合约:"contrato perpetuo",
交割合约:"Contrato de entrega",
全仓:"Almacén completo",
开多:"Abierto largo",
开空:"abierto corto",
价格:"precio",
开仓金额:"Monto de apertura",
可用金额:"Cantidad disponible",
合约金额:"Monto del contrato",
保证金:"margen",
手续费:"tasa de tramitación",
看涨:"alcista",
看跌:"Osuno",
交割时间:"el tiempo de entrega",
数量:"cantidad",
持有仓位:"mantener una posición",
当前委托:"Orden actual",
历史订单:"Órdenes históricas",
暂无数据:"Sin datos",
购买价:"precio de compra",
市价: "precio de mercado",
限价: "límite de precio",
现价:"Precio actual",
金额:"Cantidad",
盈亏:"Ganancia y perdida",
操作:"funcionar",
平仓:"Posición cercana",
撤单:"Cancelar orden",
方向:"dirección",
剩余时间:"tiempo restante",
交割时间:"el tiempo de entrega",
详情:"Detalles",
名称:"nombre",
最新价格:"Último precio",
h24涨跌:"24H altibajos",
h24涨跌幅:"24h aumentar y disminuir",
请输入开仓金额:"Por favor ingrese el monto de apertura",
请输入开仓价格:"Por favor introduce el precio de apertura.",
确定执行撤单操作:"¿Estás seguro de que deseas cancelar el pedido?",
确定执行平仓操作:"¿Está seguro de ejecutar la operación de cierre de posición?",
交割合约历史:"Historial de contrato de entrega",
历史仓位:"Posiciones históricas",
到期时间:"Fecha de caducidad",
闪兑:"Intercambio flash",
从:"de",
最大:"máximo",
可用数量:"cantidad disponible",
至:"a",
复制成功:"Copiado exitosamente",
基金理财:"Gestión financiera del fondo",
托管金额:"Monto del depósito en garantía",
总收益:"Los ingresos totales",
当日收益:"Ingreso del día",
托管订单:"Orden de depósito en garantía",
规则:"regla",
日收益:"Ingreso diario",
限额:"límite",
周期:"ciclo",
天:"cielo",
立即买入:"Comprar ahora",
购买:"Comprar",
购买日:"Fecha de compra",
起息日:"fecha valor",
派息时间:"tiempo de pago de dividendos",
每日:"a diario",
计息结束日:"Fecha de finalización del devengo de intereses",
提前赎回:"Redención temprana",
预计收益:"Ingresos estimados",
今日日收益:"Hoy (ingreso diario)",
最少可投:"Inversión mínima",
最大可投:"Máxima inversión",
请输入买入金额:"Por favor ingresa el monto de la compra",
可用金额:"Cantidad disponible",
请输入买入金额:"Por favor ingresa el monto de la compra",
质押金额:"Monto de la promesa",
累计收益:"Ingresos acumulados",
开始时间:"Tiempo de empezar",
结束时间:"Hora de finalización",
理财规则:"reglas financieras",
理财规则1:"La gestión financiera se realiza confiando USDT a la plataforma, y ​​el equipo profesional de la plataforma realiza el arbitraje financiero. Los participantes pueden obtener una parte de los ingresos de la gestión financiera de la plataforma durante el período de custodia del fondo.",
收益计算:"Cálculo de ingresos",
理财规则2:"Un miembro deposita 10.000U en la plataforma y elige un producto financiero con un ciclo de 5 días y un ingreso diario del 0,3% ~ 0,5%. El ingreso diario es el siguiente:",
最低:"más bajo",
最高:"más alto",
理财规则3:"Ambos: puedes conseguirlo después de 5 días.",
理财规则4:"Los ingresos se distribuyen diariamente. Se puede acceder a los ingresos distribuidos, retirarlos en cualquier momento y depositarlos en el capital. Después del vencimiento, se devolverán automáticamente a su cuenta.",
关于违约金:"Sobre daños y perjuicios",
理财规则5:"Si desea transferir el capital no vencido, se incurrirá en daños y perjuicios.",
理财规则6:"Indemnización liquidada = índice de liquidación x días restantes x monto de la inversión.",
理财规则7:"Ejemplo: El ratio de liquidación de daños y perjuicios de este producto es",
剩余:"Restante",
天到期投资:"Caduca en días y el monto de la inversión es",
则:"pero",
违约金:"daños y perjuicios",
实际退还本金为:"El principal real devuelto es",
现货账户:"cuenta al contado",
总资产:"Los activos totales",
充币:"depositar monedas",
提币:"retirar monedas",
闪兑:"Intercambio flash",
投资组合:"portafolio",
冻结数量:"cantidad congelada",
帮助中心:"Centro de ayuda",
自选:"Opcional",
行情:"Citas",
资金:"fondos",
资讯:"Información",
我的:"mío",
交易对:"par comercial",
最新价:"Último precio",
成交量:"Volumen",
标记价格:"marcar precio",
h24最高价:"precio más alto 24h",
h24最低价:"24h precio más bajo",
h24成交量:"Volumen de operaciones las 24 horas",
h24交易额:"Volumen de transacciones 24h",
分时:"tiempo compartido",
分1:"1 punto",
分5:"5 puntos",
分15:"15 puntos",
分30:"30 puntos",
小时1:"1 hora",
天1:"1 día",
周1:"1 semana",
月1:"Enero",
委托订单:"Orden",
最新交易:"Últimas transacciones",
买入:"Comprar",
卖出:"vender",
时间:"tiempo",
方向:"dirección",
取消自选成功:"Cancelar la selección con éxito",
添加成功:"Agregado exitosamente",
登录:"Acceso",
账户:"Cuenta",
邮箱:"Correo",
手机号:"Número de teléfono",
请输入账户:"Por favor ingresa a la cuenta",
请输入邮箱:"por favor ingrese su correo electrónico",
请输入手机号:"Por favor ingrese el número de teléfono",
密码:"contraseña",
请输入密码:"Por favor, ingrese contraseña",
忘记密码:"¿Olvidaste la contraseña?",
还没有账号:"No tienes cuenta aún",
去注册:"Ir a registrarse",
请输入登录账号:"Por favor ingrese su cuenta de inicio de sesión",
请输入登录密码:"Por favor, introduzca su contraseña",
登录失败:"error de inicio de sesion",
历史记录:"registro de historia",
充值:"completar",
提现:"retirar",
未审核:"No revisado",
成功:"éxito",
失败:"fallar",
快捷入口:"Entrada rápida",
资金密码:"Contraseña del fondo",
登录密码:"contraseña de inicio de sesión",
账变记录:"Registros de cambios de cuenta",
邀请推广:"Invitar a la promoción",
通用:"Universal",
语言:"idioma",
在线客服:"Servicio en línea",
身份认证:"Autenticación",
高级认证:"Certificación avanzada",
更多:"Más",
帮助中心:"Centro de ayuda",
关于我们:"sobre nosotros",
退出:"abandonar",
已提交身份认证:"Ha enviado su información de identidad y está bajo revisión.",
您已完成身份认证:"Has completado la verificación de identidad",
您已完成高级认证:"Has completado la Certificación Avanzada",
确定退出登录:"¿Está seguro de que desea cerrar sesión?",
资讯:"Información",
公告:"anuncio",
状态:"estado",
已成交:"Trato hecho",
委托金额:"Monto de la comisión",
剩余金额:"balance",
订单类型:"Tipo de orden",
市价委托:"orden de mercado",
限价委托:"orden límite",
订单号:"número de orden",
委托时间:"tiempo de comisión",
U本位合约历史:"Historial de contratos basado en U",
成交数量:"El número de transacciones",
实现盈亏:"Obtener ganancias y pérdidas",
推广记录:"Récord de promoción",
我的总推广:"mi promocion general",
总充值:"recarga total",
一代人数:"Número de generaciones",
二代人数:"Número de segunda generación",
三代人数:"Número de tres generaciones.",
立即推广:"Promocionar ahora",
我的推广:"mi ascenso",
用户名:"nombre de usuario",
行情:"Citas",
加密货币:"criptomoneda",
外汇:"Forex",
股票:"existencias",
现货交易:"Comercio al contado",
热门:"Popular",
涨幅榜:"Lista de ganadores",
跌幅榜:"lista de perdedores",
快速充币:"Depósito rápido",
保存二维码:"Guardar código QR",
复制地址:"Copiar dirección",
转出地址:"Dirección de transferencia (opcional)",
请输入转出地址:"Por favor ingrese la dirección de transferencia",
粘贴:"Pegar",
充币数量:"Cantidad del depósito",
请输入充币数量:"Por favor ingrese el monto del depósito",
区块链网络:"Red de cadena de bloques",
付款凭证:"Comprobante de pago (subir captura de pantalla de los detalles del pago)",
请输入充值数量:"Por favor ingresa el monto de la recarga",
充值通道:"Canal de recarga",
请选择充值币种:"Por favor seleccione la moneda de recarga",
官方充值通道:"Canal de recarga oficial",
设置密码:"configurar la clave",
确认密码:"confirmar Contraseña",
验证码:"Código de verificación",
请输入验证码:"por favor ingrese el código de verificación",
获取验证码:"obtener código de verificación",
重新发送:"Reenviar",
邀请码:"Código de invitación",
请输入邀请码:"Por favor ingresa el código de invitación",
我已阅读并同意:"He leído y estoy de acuerdo",
服务条款:"Términos de servicio",
注册:"registro",
已有账号:"Ya tienes una cuenta",
去登录:"Ir a iniciar sesión",
请再次输入密码:"Por favor ingrese la contraseña nuevamente",
请同意服务条款:"Por favor, acepte los términos del servicio",
注册失败:"registro fallido",
欢迎来到:"Bienvenido a",
全球最大的区块链资产平台:"La plataforma de activos blockchain más grande del mundo",
分享二维码:"Compartir código QR",
链接分享:"compartir enlace",
复制:"Copiar",
您的邀请码:"tu código de invitación",
到数字币地址:"A la dirección de moneda digital",
选择币种:"Seleccione el tipo de moneda",
区块链网络:"Red de cadena de bloques",
提币说明:"Instrucciones de retiro",
提现费用:"Tarifas de retiro",
可到账数量:"Cantidad disponible",
可用:"Disponible",
请输入支付密码:"Por favor ingrese la contraseña de pago",
请输入提币数量:"Por favor ingrese el monto del retiro",
全部:"todo",
支付密码:"Contraseña de pago",
地址:"DIRECCIÓN",
委托价:"Precio del pedido",
成交时间:"tiempo de transacción",
成交金额:"Rotación",
委托中:"En comisión",
持仓中:"En posición",
平仓中:"Cierre de posición",
已平仓:"Posición cerrada",
开仓倍数:"Apertura múltiple",
委托价格:"Precio de comisión",
收盘价:"Precio de cierre",
收益率:"tasa de retorno",
平仓时间:"hora de cierre",
请输入转换数量:"Por favor ingrese la cantidad de conversión",
请上传付款凭证:"Por favor cargue el comprobante de pago",
开盘价:"precio de apertura",
开市中:"Abierto",
已休市:"El mercado ha sido cerrado.",
美股:"acciones estadounidenses",
平仓价:"Precio de cierre",
到期结算完成:"Liquidación de vencimiento completada",
印度股票:"acciones indias",
马来股票:"Acciones malayas",
结算中:"Asentamiento",
越南股票:"acciones de vietnam",
设置资金密码:"Establecer contraseña de fondo",
请输入资金密码:"Por favor ingrese la contraseña del fondo",
取消:"Cancelar",
确定:"Seguro",
止损价:"Precio de parada de pérdidas",
请输入止损价格:"Por favor introduzca el precio del stop loss",
请输入止盈价格:"Por favor ingrese el precio de toma de ganancias",
止盈价:"Precio de toma de ganancias",
设置止盈止损:"Establecer toma de ganancias y detener pérdidas",
请输入关键词:"Por favor ingrese una palabra clave",
搜索结果:"Resultados de la búsqueda",
添加收款方式:"Añadir método de pago",
高级认证:"Certificación avanzada",
历史委托:"comisión histórica",
选择区域码:"Seleccionar código de área",
请上传身份证图片:"Por favor sube una foto de tu documento de identidad.",
请上传护照照片:"Por favor sube una foto de pasaporte",
请输入提币地址:"Por favor ingrese la dirección de retiro",
设置语言:"configuración de idioma",
最低金额: "Monto minimo",
购买金额: "precio de compra",
请输入要搜索的国家名称: "Por favor ingrese el nombre del país que desea buscar",
确定执行该操作: "Confirma para hacer esto?",
历史搜索: "Búsquedas históricas",
现货持仓: "Posición del punto",
永续持仓: "Posición perpetua",
到期结算中: "Liquidación al vencimiento",
火花图: "diagrama de chispa",
计价单位: "Unidad de ventas",
您拒绝了链接: "Rechazaste el enlace",
连接钱包成功: "Conexión de billetera exitosa",
已断开钱包: "Cartera desconectada",
钱包切换成功: "Cambio de billetera exitoso",
请先安装钱包插件: "Primero instale el complemento de billetera",
连接钱包: "Conectar billetera",
交易: "Comercio",
确认报价: "Confirmar cotización",
您将获得: "conseguirás",
兑换自: "Canjear desde",
汇率: "tipo de cambio",
返回: "devolver",
兑换: "intercambio",
消息: "información",
身份证反面照片: "Foto del reverso del documento de identidad.",
身份证正面照片: "Foto frontal del documento de identidad",
手持身份证照片: "Foto de sosteniendo una tarjeta de identificación",
划转: "transferir",
请输入划转数量: "Por favor ingrese el monto de la transferencia(USDT)",
邀请链接: "Enlace de invitación",
资料总览: "Resumen de datos",
推广规则: "Reglas de promoción",
总邀请人数: "Número total de invitados",
总佣金: "comisión total",
安全绑定: "encuadernación segura",
规则1: "1.Esta dirección solo acepta {type}. No transfiera activos que no sean de {type} a esta dirección; de lo contrario, los activos no se recuperarán.",
规则2: "2.Después de recargar la dirección anterior, debe esperar a que el nodo de red confirme. Una vez que el nodo de red lo confirme, los activos llegarán automáticamente a su cuenta. Le notificaremos el estado de llegada en forma de un anuncio en el sitio web.",
规则3: "3.Tu dirección de recarga no cambiará con frecuencia y podrás recargar repetidamente; si hay algún cambio, te lo notificaremos a través de un anuncio en el sitio web.",

安全中心: "Centro de Seguridad",
绑定手机号: "Vincular número de teléfono móvil",
认证中心: "Centro de certificación",
身份认证: "Autenticación",
认证要求: "Requisitos de certificación",
政府发行的证件: "Documentos emitidos por el gobierno",
功能与限制: "Características y limitaciones",
无限额: "Sin límite",
预计审核时间: "Tiempo estimado de revisión: 60 minutos",
开始认证: "Iniciar certificación",
充币规则: "Reglas de depósito",
加密货币股票多类选择: "Selección múltiple de acciones de criptomonedas",
    个人中心: "centro personal",
    充值记录: "Registro de recarga",
    提现记录: "Registro de retiros"
  
  }
  
  
  


// WEBPACK FOOTER //
// ./src/lang/es.js